import React, { useContext, useRef } from "react"
import HTML from "@convertkit/slate-html-serializer"
import classNames from "classnames"
import DefaultEditor from "../.."
import { useTemplateState, useOverride, useIsEditing } from "../editor"
import { ClosestEditableContext } from "../closest-editable-detector"

const html = new HTML()

function Editable({ name }) {
  const [state, dispatch] = useTemplateState()
  const Editor = useOverride("Editor") || DefaultEditor
  const serializer = useOverride("serializer") || html
  const isEditing = useIsEditing()
  const editableState = useContext(ClosestEditableContext)
  const element = useRef()

  function handleChange({ value }) {
    dispatch({ type: "update_content", content: { [name]: value } })
  }

  const content = state.content[name]

  const document = content.document

  const empty = document.text === "" && document.nodes.size === 1
  const active = editableState.closest === name && editableState.distance < 50

  const className = classNames("editable", name, {
    active,
    empty
  })

  return isEditing ? (
    <div
      className="editable-container"
      ref={element}
      data-editable={name}
      data-empty={empty}
      data-active={active}
    >
      <Editor className={className} value={content} onChange={handleChange} />
    </div>
  ) : !empty ? (
    <div
      className={name}
      dangerouslySetInnerHTML={{ __html: serializer.serialize(content) }}
    />
  ) : null
}

export default Editable
